import SEO from "../components/SEO";
import Breadcrumbs from "../components/layout/Breadcrumbs";
import SectionHeading from "../components/blocks/SectionHeading";
import CTASection from "../components/blocks/CTASection";
import FAQ from "../components/blocks/FAQ";
import { FrameworkCard } from "../components/blocks/Cards";
import { FRAMEWORKS, TOOLBOX_FAQS } from "../data/frameworks";

export default function ThinkingToolboxPage() {
  return (
    <>
      <SEO
        title="The Vantage Thinking Toolbox™ — Proprietary Thinking Frameworks"
        description="Thirteen proprietary thinking frameworks — from First Principles and Strategic Thinking to Executive and Future Thinking — that improve the quality of business judgement."
        path="/thinking-toolbox"
      />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Thinking Toolbox™" }]} />

      <section className="bg-navy">
        <div className="container-x py-16 sm:py-20">
          <p className="eyebrow-light">The Vantage Thinking Toolbox™</p>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-semibold leading-tight text-white sm:text-5xl">
            The thinking platform behind every Vantage programme.
          </h1>
          <span className="gold-rule mt-8 !w-24" aria-hidden="true" />
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-platinum md:text-lg">
            The Toolbox is a structured set of thirteen thinking frameworks. Each framework defines what it is,
            why it matters, when to use it and how it works — so better thinking becomes a repeatable discipline,
            not an accident of talent.
          </p>
        </div>
      </section>

      <section className="container-x py-16 sm:py-24" data-testid="toolbox-frameworks">
        <SectionHeading
          eyebrow="The Frameworks"
          title="Thirteen frameworks, fully developed."
          intro="Each framework includes its logic, when to use it, how it works, business application, a worked example and a practice exercise."
        />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FRAMEWORKS.map((f) => (
            <FrameworkCard key={f.slug} framework={f} />
          ))}
        </div>
      </section>

      <FAQ items={TOOLBOX_FAQS} title="About the Thinking Toolbox™" />

      <CTASection
        title="Learn to apply the frameworks."
        text="The Toolbox is the intellectual backbone of Vantage programmes — where frameworks become capability."
        primaryLabel="Explore Programmes"
        primaryTo="/programmes"
        secondaryLabel="Talk to Vantage"
        secondaryTo="/contact"
        testId="toolbox-cta"
      />
    </>
  );
}
